import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { initTempDashboard } from '@store/trends/tempDashboard/nocDrilldown/actions';
import tempDashboardSelector from '@store/trends/tempDashboard/nocDrilldown/selectors';

import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import tempDashboard from '../common/tempDashboard';
import Main from '../main/Main';
import injectorServer from '../common/injectorServer';

import { createStore } from 'jotai';
import { summaryPanelAtom } from '@src/atoms/panels';
import { widgetPanelVisibilityAtom } from '@src/components/metrics-panel-hz/atoms';

function initStore() {
  const store = createStore();
  store.set(summaryPanelAtom, false);
  store.set(widgetPanelVisibilityAtom, false);
  return store;
}

const tempDashboardDetailsSelector = createSelector(
  tempDashboardSelector,
  (tempDashboardStore) => ({
    dashboard: {},
    dashboardType: DASHBOARD_TYPE.TRENDS,
    isFetching: tempDashboardStore.isFetching,
    initStore,
  }),
);

const TempTrends = compose(
  connect(tempDashboardDetailsSelector, { init: initTempDashboard }),
  tempDashboard,
)(Main);

export const TempVdashDrilldownDashboard = injectorServer(
  {},
  { pageType: PAGE_TYPE.TEMP_DASHBOARD },
)(TempTrends);

export default TempVdashDrilldownDashboard;
